<section class="light white p0 c2">
  <div class="container c2">
    <div class="best-selling c2">
      <img class="bg c2" [lazyLoad]="'https://cdn.ggboost.com/images' + background[game]" [alt]="game + ' background'"/>
      <img *ngIf="game === 'valorant'" class="knife" [src]="'https://cdn.ggboost.com/images' + extra[game]" alt="valorant jett knife">
      <div class="content-box c2">
        <div class="typo c2">
          <h2>
            {{ title[lang]?.[game] || title['en'][game] }}
          </h2>
          <p>
            {{ miniTitle[lang]?.[game] || miniTitle['en'][game] }}
          </p>
        </div>
        <div class="spec-wrap c2">
          <div class="spec c2" style="--i: #e7f7ff">
            <div class="ico c2" style="--i: #9a99f2">
                <img [lazyLoad]="'https://cdn.ggboost.com/images/' + game + '/icons/main1.webp'" [alt]="game + ' ' + (point1[lang]?.[game] || point1['en'][game]) + ' icon'">
            </div>
            <div>
              <h3>{{ point1[lang]?.[game][0] || point1['en'][game][0] }}</h3>
              <p>{{ point1[lang]?.[game][1] || point1['en'][game][1] }}</p>
            </div>
          </div>
          <div class="spec c2" style="--i: #e9fff8">
            <div class="ico c2" style="--i: #82d9c8">
                <img [lazyLoad]="'https://cdn.ggboost.com/images/' + game + '/icons/main2.webp'" [alt]="game + ' ' + (point2[lang]?.[game] || point1['en'][game]) + ' icon'">
            </div>
            <div>
              <h3>{{ point2[lang]?.[game][0] || point2['en'][game][0] }}</h3>
              <p>{{ point2[lang]?.[game][1] || point2['en'][game][1] }}</p>
            </div>
          </div>
          <div class="spec c2" style="--i: #fff3f3">
            <div class="ico c2" style="--i: #ff6c6c">
                <img [lazyLoad]="'https://cdn.ggboost.com/images/' + game + '/icons/main3.webp'" [alt]="game + ' ' + (point3[lang]?.[game] || point1['en'][game]) + ' icon'">
            </div>
            <div>
              <h3>{{ point3[lang]?.[game][0] || point3['en'][game][0] }}</h3>
              <p>{{ point3[lang]?.[game][1] || point3['en'][game][1] }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
